import { SVGProps, Ref, forwardRef } from 'react';

export const BackwardFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.006 4.761c1.354-.65 2.031-.975 2.513-.605.48.37.481 1.216.481 2.908v1.871c0 1.692 0 2.539-.481 2.91-.482.37-1.16.044-2.513-.607l-1.945-.936C1.02 9.322 0 8.831 0 8c0-.83 1.02-1.322 3.06-2.302z"
                fill="currentColor"
            />
            <path
                d="M13.006 4.761c1.354-.65 2.031-.975 2.513-.605.48.37.481 1.216.481 2.908v1.871c0 1.692 0 2.539-.481 2.91-.482.37-1.16.044-2.513-.607l-1.946-.936C9.02 9.322 8 8.831 8 8c0-.83 1.02-1.322 3.06-2.302z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BackwardFilledSize16Glyph.displayName = 'BackwardFilledSize16Glyph';
